<!--
 * @Description: 数字拜访问卷详情
 * @Date: 2025-04-11 18:44:27
-->
<template>
  <div class="question-detail">
    <BaseDescriptions
      v-for="(topic, index) in questionInfo"
      :key="index"
      :title="getTitle(topic, index)"
      :column="1"
      size="large"
      direction="vertical"
    >
      <BaseDescriptionsItem
        v-if="topic.remark"
        :label="`备注：${topic.remark}`"
      ></BaseDescriptionsItem>
      <template v-if="index === 0">
        <BaseDescriptionsItem
          :key="index"
          v-for="(value, index) in topic.values"
          style="display: flex; align-items: center"
        >
          <span style="width: 30px">{{ value.label }}：</span>
          <span>{{ value.values }}</span>
        </BaseDescriptionsItem>
      </template>
      <template v-else-if="isArray(topic.values)">
        <BaseDescriptionsItem
          :key="index"
          v-for="(value, index) in topic.values"
          style="display: flex; align-items: center"
        >
          {{ value.informationName || '无' }}
        </BaseDescriptionsItem>
      </template>
      <!-- 数字拜访图片 -->
      <template v-else-if="[20].includes(topic.topicType)">
        <BaseDescriptionsItem>
          <div v-if="topic.values">
            <img @click="onChangeShowIndex(topic.values)" :src="topic.values" />
          </div>
          <div v-else>无</div>
        </BaseDescriptionsItem>
      </template>
      <template v-else>
        <BaseDescriptionsItem>
          {{ topic.values || '无' }}
        </BaseDescriptionsItem>
      </template>
    </BaseDescriptions>
  </div>
</template>
<script lang="tsx" setup>
import { isArray } from 'lodash';
import { BaseDescriptions, BaseDescriptionsItem } from 'xrk-components';

withDefaults(
  defineProps<{
    questionInfo: any;
  }>(),
  {
    questionInfo: () => ({})
  }
);
const emits = defineEmits(['changeImgUrl']);
const onChangeShowIndex = url => {
  emits('changeImgUrl', url);
};
const getTitle = (topic, index) => {
  return `${index + 1}.${topic.label}`;
};
</script>
<style lang="scss" scoped>
.question-detail {
  img {
    width: 100px;
    cursor: pointer;
  }
  .xrk-descriptions__cell {
    margin-bottom: 10px;
  }
}
</style>
